import { type TenantFeatureConfigurationType } from '@repo/utils';

export const getTenantFeatureConfiguration = `
query ($featureName: [String!]){
  tenantFeatureConfiguration(featureName: $featureName){
    id
    featureName
    configKey
    configValue
    dataType
    createdAt
    updatedAt
  }
}
`;

export interface GetTenantFeatureConfigurationType {
  tenantFeatureConfiguration: TenantFeatureConfigurationType[];
}
